(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["remarque-object-filter"] && !Shopify.designMode) return;
  try {
    (() => {
    const nav = document.querySelector('[data-remarque-object-filter]');
    if (!nav) return;

    const selectedTags = new URLSearchParams(window.location.search)
      .getAll('filter.p.tag')
      .sort()
      .join(',');
    const links = nav.querySelectorAll('[data-object-tags]');

    links.forEach((link) => {
      const isSelected = link.dataset.objectTags === selectedTags;
      link.classList.toggle('is-selected', isSelected);
      if (isSelected) link.setAttribute('aria-current', 'page');
      else link.removeAttribute('aria-current');
    });

    const selectedLink = nav.querySelector('.is-selected');
    selectedLink?.scrollIntoView({ block: 'nearest', inline: 'center' });
  })();
  } catch(e) { console.error(e); }
})();

})();
